import ServiciosGeneral from "./ServiciosGeneral";

const servicios = {
  getTareasAsignadas: ServiciosGeneral.llamarServidor("/PTareasAsignadas/getTareasAsignadas"),
  cambioEstatus: ServiciosGeneral.llamarServidorRespuesta("/PTareasAsignadas/cambioEstatus"),
  // cerrartareasUpdate: ServiciosGeneral.llamarServidorRespuesta("Tareas/cerrartareasUpdate"),
  // tareasAll: ServiciosGeneral.llamarServidorRespuestaPost("Tareas/tareasAll"),
};
export default servicios;
